import React, { Component } from 'react';
import ClientHeader from './clientheader';
import QuizContainer from './QuizContainer'
import Container from '@material-ui/core/Container';
import { Box } from '@material-ui/core';
import Error from './Error';

//import theme from './theme.js'
//these will need to go elsewhere when we build out a menu and
//allow users to take multiple assessments within our site
//At least the assmnt_guid will, as the assessment will change.  
//But Perhaps at this layer it is a constant, and App.js will need to be
//moved to a new component (which it should anyway, honestly)
const org_guid = new URLSearchParams(window.location.search).get('org')
const assmnt_guid = new URLSearchParams(window.location.search).get('assmt')

window.onbeforeunload = (e) => {
    console.log("warning!")
    e.preventDefault()
    e.returnValue = "Are you sure you want to lose your progress?"
}

window.addEventListener("pageshow", function(){
    return "null"
})

class Assessment extends Component {
    constructor(props){
        super(props);
        this.state = {
          isLoaded: false,
             viewInstance: [],
             clientColor: '#158f98',
             clientColorSecondary: '#158f98',
             languageISO2:'',
             backgroundColor: 'rgba(19,142,152,0.3)',
             loadingError: false,
             timeout: 1000 * 5 * 60,
             countryList: ''
        }
    }
    
//orgguid=896e7ab9-a3f3-43e0-88a3-6d6db08fa824
//assmntguid=C3725D0B-ED29-4B9A-B943-EF9299C1B0FF



    componentDidMount() {
        
        if(org_guid && assmnt_guid){
            fetch('../../WsWebServiceWellSuite/GetViewInstancePublic/' + org_guid + '/-1/' + assmnt_guid + '/', 
                {
                headers:{'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}
            })
            .then(response => response.json())
            .then(response => {
                if(response.Success){
                    var color = response.Info[0].ViewInstanceData[1].OrganizationSettingValues[0].List['THEME COLOR'].replace('#', '')
                    var secondaryColor = response.Info[0].ViewInstanceData[1].OrganizationSettingValues[0].List['THEME COLOR SECONDARY'].length ? 
                        response.Info[0].ViewInstanceData[1].OrganizationSettingValues[0].List['THEME COLOR SECONDARY'].replace('#', '') :
                        response.Info[0].ViewInstanceData[1].OrganizationSettingValues[0].List['THEME COLOR'].replace('#', '')
                    var countryList = response.Info[0].ViewInstanceData[1].OrganizationSettingValues[0].List['COUNTRY AUTOCOMPLETE LIST']


                    // Language ISO2 is needed to send the correct URL to Google's Place API. First check the session variable. If it's empty, fallback to the organization setting.
                    var     languageISO2   = '';
                            languageISO2   = response.Info[0].ViewInstanceData[1].SessionVariableValues[0].List['LANGUAGEISO2'];
                    if (languageISO2 == ''){
                        var languageISO2   = response.Info[0].ViewInstanceData[1].OrganizationSettingValues[0].List['LANGUAGEISO2'];
                    }   

                    //easiest way to set global variables are setting windows variables
                    window.$primaryColor = '#' + color;
                    window.$secondaryColor = '#' + secondaryColor;
                    //since we removed Name for a reason, and now it's back, commenting this out
                    //Wellactivate should always be the tab name... I think 
                    //document.title = response.Info[0].ViewInstanceData[0].LandingPage.HeaderFrame.Name.length ? response.Info[0].ViewInstanceData[0].LandingPage.HeaderFrame.Name : "WellActivate"
                        
                    this.setState({viewInstance: response.Info[0].ViewInstanceData[0].LandingPage,
                        clientColor: color,
                        clientColorSecondary: '#' + secondaryColor,
                        languageISO2:languageISO2,
                        timeout: response.Info[0].ViewInstanceData[1].OrganizationSettingValues[0].List['SESSION TIMEOUT SECONDS'] * 1000,
                        countryList: countryList})
                } else {
                    
                    if(response.Status[0].ViewInstanceData){
                        var color = response.Status[0].ViewInstanceData[1].OrganizationSettingValues[0].List['THEME COLOR'].replace('#', '')
                        var secondaryColor = response.Status[0].ViewInstanceData[1].OrganizationSettingValues[0].List['THEME COLOR SECONDARY'] ? response.Status[0].ViewInstanceData[1].OrganizationSettingValues[0].List['THEME COLOR SECONDARY'].replace('#', '') : color
                        window.$primaryColor = color;
                        window.$secondaryColor = secondaryColor
                        this.setState({viewInstance: response.Status[0].ViewInstanceData[0].ErrorViewInstance,
                        clientColor: color,
                        loadingError: true})
                        
                    } else {
                         var errorJSON = {"Error" : [{
                            "ComponentClass": "TEXTAREA",
                            "ComponentFamily": "VARIANT",
                            "ComponentType": "HEADER",
                            "ComponentContent": {
                              "Title": "Error",
                              "GradeLabel": ""
                            }
                          },
                          {
                            "ComponentClass": "TEXTAREA",
                            "ComponentFamily": "VARIANT",
                            "ComponentType": "SUBHEADER",
                            "ComponentContent": {
                              "Content": response.Status[0].ErrorMessage,
                              "ContentType": ""
                            }
                          }]}
                         this.setState({
                             viewInstance: errorJSON,
                             clientColor: "158F98",
                             loadingError: true
                         })
                    }
                    
                }
                
            })
            .then(response => {
                this.getClientColor()
            })
            .then(()=>{
                this.setState({isLoaded: true})
            })
                .catch(console.log)
        }
    }

    componentWillUnmount() {
        
    }

    getClientColor(){
        //if default just skip
        if(this.state.clientColor != '#158f98'){
            let hex = this.state.clientColor.replace('#', '')
            let r = parseInt(hex.substring(0,2), 16);
            let g = parseInt(hex.substring(2,4), 16);
            let b = parseInt(hex.substring(4,6), 16);

            //we use rgba for IE and Edge compatibility
            let result = 'rgba(' + r + ',' + g + ',' + b + ',0.3)'

            this.setState({
                backgroundColor: result,
                clientColor: "#" + hex
            })
        }
    }

    render() {
        var header
        if(this.state.viewInstance.ClientLogo){
            header = <ClientHeader clientheader={this.state.viewInstance.ClientLogo} />
                        
        }
        if(this.state.isLoaded && !this.state.loadingError){
            return (
                <div style={{backgroundColor: this.state.backgroundColor, overflowY: 'scroll', height: '100%', width: '100%', position: 'fixed'}}>
                    <Box>
                        {header}
                        <Container maxWidth="md">
                            <QuizContainer {...this.state.viewInstance} 
                                clientColor             = {this.state.clientColor} 
                                clientColorSecondary    = {this.state.clientColorSecondary} 
                                timeout                 = {this.state.timeout}
                                countryList             = {this.state.countryList} 
                                languageISO2            = {this.state.languageISO2}/>
                        </Container>
                    </Box>
                </div>
                
            )
        } if(this.state.isLoaded && this.state.loadingError){
            return (
                <div style={{backgroundColor: this.state.backgroundColor, overflowY: 'scroll', height: '100%', width: '100%', position: 'fixed'}}>
                    <Box>
                        {header}
                        <Container maxWidth="md">
                            <Error error = {this.state.viewInstance.Error} clientColor = {this.state.clientColor} />
                        </Container>
                    </Box>
                </div>
                
            )
        } else {
            return <div>Loading</div>
        }
    }
}
export default Assessment;
